<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row" v-if="userData.permissions['referpatient']==1">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="mb-2 float-end">
              <b-button v-b-modal.new-referral size="sm" variant="primary"><i class="mdi mdi-plus"></i> New Referral</b-button>
            </div>
            <div class="clearfix"></div>
            <div class="row">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show <b-form-select class="form-select form-select-sm mx-1" v-model="perPage" size="sm" :options="Options"></b-form-select> entries
                  </label>
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end" >
                  <label class="d-inline-flex align-items-center">
                    Search: <b-form-input v-model="filter" type="search" placeholder="Search..." class="form-control form-control-sm ms-2"></b-form-input>
                  </label>
                </div>
              </div>
            </div>
            <div class="table-responsive">
              <b-table
                :items="Items"
                :fields="Fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="Filtered"
                :busy="IsBusy"
              >
              
              <template #table-busy><div class="text-center text-primary my-2"><b-spinner class="align-middle" type="grow" small></b-spinner> <strong>No Data Found</strong></div></template>
              <template #cell(index)="data">
                {{ data.index + 1 }}
              </template>
              <template #cell(patient)="data">
                {{ data.item.patient.name }}
              </template>
              <template #cell(patientid)="data">
                {{ data.item.patient.patient_id }}
              </template>
              <template #cell(patientct)="data">
                0{{ data.item.patient.telephone }}
              </template>
              <template #cell(actions)="data">
                <div class="btn-group">
                <b-button @click="edit(data.item.id,data.item.patient.patient_id,data.item.investigations,data.item.reason,data.item.refered_to,data.item.referral_date)" type="button" class="btn-sm btn" variant="primary" v-b-modal.edit> <i class="mdi mdi-square-edit-outline"></i> </b-button>
                <!-- <router-link :to="{ path: '/printreferpatient',  query: { patient_id: data.item.patient.patient_id,id: data.item.id}}" type="button" class="btn-sm btn btn-info"> <i class="mdi mdi-printer"></i> </router-link> -->
                <router-link :to="{ path: '/printreferpatient',  query: {id: data.item.id}}" type="button" class="btn-sm btn btn-info"> <i class="mdi mdi-printer"></i> </router-link>
                <b-button @click="remove(data.item.id,data.item.patient.name)" type="button" class="btn-sm btn" variant="danger"  v-b-modal.delete> <i class="mdi mdi-trash-can"></i> </b-button>
                </div>
              </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="currentPage" :total-rows="List" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <img src="@/assets/images/profile-img.png" alt class="img-fluid" /><br><br>
            <center><span class="text-primary h6">You have no permission to View Refered Patients</span></center>
          </div>
        </div>
      </div>
    </div>

    <b-modal id="new-referral" centered title="New Referral" title-class="font-18" hide-footer>
        <form @submit.prevent="addReferral">
          <div class="form-group mb-2">
            <label>Patient's Name</label>
              <multiselect v-model="patient" :options="patients" :custom-label="customLabel" label="name"></multiselect>
            </div>
            <div class="form-group mb-2">
            <label>Investigations</label>
              <textarea v-model="investigations" rows="2" class="form-control"></textarea>
            </div>
            <div class="form-group mb-2">
            <label>Reason</label>
              <textarea v-model="reason" rows="2" class="form-control"></textarea>
            </div>
            <div class="form-group mb-2">
            <label>Refer To</label>
            <input v-model="refer_to" type="text" required class="form-control" />
            </div>
            <div class="form-group mb-2">
            <label>Referral Date</label>
            <input v-model="referral_date" type="date" required class="form-control" />
            </div>
            <div class="form-group d-flex justify-content-end">
                <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('new-referral')" >Close</b-button>
                <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> Submit</b-button>
            </div>
        </form>
    </b-modal>

    <b-modal id="edit-referral" centered title="Edit Referral" title-class="font-14" hide-footer>
        <form @submit.prevent="editReferral">
            <div class="form-group mb-2">
            <input v-model="id" type="hidden">
            <label>Patient</label>
            <b-form-select v-model="patient" required :options="patients" class="mb-3 form-control" value-field="patient_id" text-field="name"></b-form-select>
            </div>
            <div class="form-group mb-2">
            <label>Investigations</label>
              <textarea v-model="investigations" rows="2" class="form-control"></textarea>
            </div>
            <div class="form-group mb-2">
            <label>Reason</label>
              <textarea v-model="reason" rows="2" class="form-control"></textarea>
            </div>
            <div class="form-group mb-2">
            <label>Refer To</label>
            <input v-model="refer_to" type="text" required class="form-control" />
            </div>
            <div class="form-group mb-2">
            <label>Referral Date</label>
            <input v-model="referral_date" type="date" required class="form-control" />
            </div>
            <div class="form-group d-flex justify-content-end">
                <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('edit-referral')" >Close</b-button>
                <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> Submit</b-button>
            </div>
        </form>
    </b-modal>

    <b-modal id="delete-referral" centered title="Delete Referral " title-class="font-18" hide-footer>
        <form @submit.prevent="removeReferral">
            <input v-model="id" type="hidden">
              Are you sure you want to delete the Referral for : <b>{{ patient }}</b> ?
            <div class="form-group d-flex justify-content-end">
                <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('delete-referral')" >Close</b-button>
                <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> YES</b-button>
            </div>
        </form>
    </b-modal>

  </Layout>
</template>

<script>
import axios from "axios";
import Layout from "../../layouts/main";
import Multiselect from "vue-multiselect";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { patientMethods,referralsMethods, referralsComputed, patientComputed } from "@/state/helpers";

export default {
  page: {
    title: "Referred Patients",
    meta: [{ name: "description", content: appConfig.description,},],
  },
  components: {
    Multiselect,Layout,PageHeader,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      title: "Referred Patients",
      items: [ {text: "Dashboard",to: "/",}, {text: "Referred Patients",active: true, }, ],
      TotalRows: 1,
      currentPage: 1,
      perPage: 10,
      Options: [10, 50, 100, 150, 200],
      filter: null,
      todoFilter: null,
      filterOn: [],
      sortDesc: true,
      isBusy: true,
      fields: [
          { key: 'index', label: '#', visible: true },
          { key: 'id', label: 'ID', visible: false },
          { key: 'patientid', label: 'Patient ID', visible: true },
          { key: 'patient', label: 'Patient Name', visible: true },
          { key: 'patientct', label: 'Patient Contact', visible: true },
          { key: 'investigations', label: 'Investigations', visible: true },
          { key: 'reason', label: 'Reason', visible: true },
          { key: 'refered_to', label: 'Refered To', visible: true },
          { key: 'referral_date', label: 'Referral Date', visible: true },
          { key: 'actions', label: 'Actions', visible: true },
        ],
      id:'',
      patient:'',
      investigations:'',
      referral_date:new Date().toLocaleDateString('fr-CA'),
      refer_to:'',
      reason:'',
    };
  },
  computed: {
    ...referralsComputed,
    ...patientComputed,
    List() { return this.patientreferrals.length; },
    Fields() { return this.fields.filter(field => field.visible) },
    Items() { return this.patientreferrals.map((d) => ({...d }))},
    IsBusy() { let a=false; if (this.patientreferrals.length>0) { a=false;} else { a=true;} return a },
  },
  mounted() {
    this.fetchPatientReferrals();
    this.fetchPatients();
    this.TotalRows = this.patientreferrals.length;
    this.isBusy=false;
  },
  methods: {
    ...referralsMethods,
    ...patientMethods,
    customLabel ({ patient_id, name, telephone }) {
      return `${patient_id} – ${name} – ${telephone}`
    },
    Filtered(filteredItems) {
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },
    edit(id,patient,investigations,reason,refer_to,referral_date){
      this.id=id;
      this.patient=patient;
      this.refer_to=refer_to;
      this.referral_date=referral_date;
      this.investigations=investigations;
      this.reason=reason;
      this.$bvModal.show('edit-referral')
    },
    
   
    remove(id,patient){
      this.id=id;
      this.patient=patient;
      this.$bvModal.show('delete-referral')
    },
    async addReferral() { 
      let formData = new FormData();
      formData.append("patient", this.patient.patient_id);
      formData.append("referral_date", this.referral_date);
      formData.append("refered_to", this.refer_to);
      formData.append("investigations", this.investigations);
      formData.append("reason", this.reason);
      let url = "/addreferral";
      await axios.post(url, formData).then((response) => {
      if (response.status == 200) {
          this.fetchPatientReferrals();
          this.$bvModal.hide('new-referral');
          this.patient="";
          this.referral_date="";
          this.investigations="";
          this.reason="";
          this.refer_to="";
          this.$toast.success("New Patient Referral Added");
      }
      });
    },
    async editReferral(){ 
    let formData = new FormData();
    formData.append("id", this.id);
    formData.append("patient", this.patient);
    formData.append("referral_date", this.referral_date);
    formData.append("investigations", this.investigations);
    formData.append("refered_to", this.refer_to);
    formData.append("reason", this.reason);
    let url = "/updatereferral";
    await axios.post(url, formData).then((response) => {
      if (response.status == 200) {
        this.fetchPatientReferrals();
        this.$bvModal.hide('edit-referral');
        this.patient="";
          this.referral_date="";
          this.investigations="";
          this.refer_to="";
          this.reason="";
          this.$toast.success("Patient Referral Updated");
      }
    });
    },
    async removeReferral() { 
    let formData = new FormData();
    formData.append("id", this.id);
    let url = "/removereferral";
    await axios.post(url, formData).then((response) => {
      if (response.status == 200) {
        this.fetchPatientReferrals();
        this.$bvModal.hide('delete-referral');
        this.$toast.error("Patient Referral Deleted");
      }
    });
    },
  },
};
</script>